import React from 'react';

const WifiBoxIcon = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    className={className}
    {...props}
    width="88"
    height="88"
    viewBox="0 0 88 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_9144_6814)">
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H76C80.4183 0 84 3.58172 84 8V76C84 80.4183 80.4183 84 76 84H8C3.58172 84 0 80.4183 0 76V8Z"
        fill="white"
      />
      <path
        d="M8 0.5H76C80.1421 0.5 83.5 3.85786 83.5 8V76C83.5 80.1421 80.1421 83.5 76 83.5H8C3.85786 83.5 0.5 80.1421 0.5 76V8C0.5 3.85786 3.85786 0.5 8 0.5Z"
        stroke="black"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.286 35.5723C34.0491 25.8092 49.8783 25.8092 59.6414 35.5723C60.1295 36.0605 60.1295 36.8519 59.6414 37.3401L58.7575 38.224C58.5231 38.4585 58.2052 38.5902 57.8736 38.5902C57.5421 38.5902 57.2242 38.4585 56.9897 38.2241C48.6911 29.9254 35.2363 29.9254 26.9377 38.2241C26.7033 38.4585 26.3853 38.5902 26.0538 38.5902C25.7222 38.5902 25.4043 38.4585 25.1699 38.224L24.286 37.3401C23.7979 36.8519 23.7979 36.0605 24.286 35.5723ZM29.5893 40.8757C36.4235 34.0415 47.5039 34.0415 54.3381 40.8757C54.8262 41.3639 54.8262 42.1553 54.3381 42.6435L53.4543 43.5274C53.2198 43.7618 52.9019 43.8935 52.5704 43.8935C52.2388 43.8935 51.9209 43.7618 51.6865 43.5274C46.3168 38.1577 37.6107 38.1577 32.241 43.5274C31.7529 44.0155 30.9614 44.0155 30.4733 43.5274L29.5894 42.6435C29.3549 42.4091 29.2232 42.0911 29.2232 41.7596C29.2232 41.4281 29.3549 41.1101 29.5893 40.8757ZM34.9295 46.1789C38.8347 42.2737 45.1663 42.2737 49.0716 46.1789C49.5597 46.6671 49.5597 47.4585 49.0716 47.9467L48.1877 48.8306C47.9533 49.065 47.6353 49.1967 47.3038 49.1967C46.9723 49.1967 46.6544 49.065 46.4199 48.8306C43.9792 46.3898 40.0219 46.3898 37.5811 48.8306C37.0929 49.3187 36.3015 49.3187 35.8133 48.8306L34.9295 47.9467C34.4413 47.4585 34.4413 46.6671 34.9295 46.1789ZM40.2328 51.4822C41.2091 50.5059 42.792 50.5059 43.7683 51.4822C44.2564 51.9704 44.2564 52.7618 43.7683 53.25L42.8844 54.1339C42.65 54.3683 42.332 54.5 42.0005 54.5C41.669 54.5 41.3511 54.3683 41.1166 54.1339L40.2328 53.25C39.7446 52.7618 39.7446 51.9704 40.2328 51.4822Z"
      fill="black"
    />
    <defs>
      <filter
        id="filter0_d_9144_6814"
        x="0"
        y="0"
        width="88"
        height="88"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9144_6814"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_9144_6814"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default WifiBoxIcon;
